import { DiscountType, DiscountScope } from '@squareup/sq-addons-web-sdk';

/** Converter for Square discount items <-> SDK discounts. */
export class OrderDiscountsConverter {
  /**
   * Converts Square discount items to SDK discounts.
   * @param orderLineDiscounts Square discount items.
   * @returns SDK discounts.
   */
  static orderLineDiscountsToDiscounts(orderLineDiscounts) {
    return orderLineDiscounts.map((orderLineDiscount) => {
      return {
        uid: orderLineDiscount.uid ?? '',
        name: orderLineDiscount.name ?? '',
        type: orderLineDiscount.type ?? DiscountType.UNKNOWN_DISCOUNT,
        scope: orderLineDiscount.scope ?? DiscountScope.OTHER_DISCOUNT_SCOPE,
        amountMoney: {
          amount: Number(orderLineDiscount.amountMoney?.amount ?? 0),
          currency:
            orderLineDiscount.amountMoney?.currency ?? 'UNKNOWN_CURRENCY',
        },
        appliedMoney: {
          amount: Number(orderLineDiscount.appliedMoney?.amount ?? 0),
          currency:
            orderLineDiscount.appliedMoney?.currency ?? 'UNKNOWN_CURRENCY',
        },
        metadata: orderLineDiscount.metadata ?? {},
      };
    });
  }
}
